 import icon1 from "../../assets/images/all-img/service/icon1.png";
import icon2 from "../../assets/images/all-img/service/icon2.png";
import icon3 from "../../assets/images/all-img/service/icon3.png";

 export default function FeatureSection() {
	return (
		<div className="section bg-warning-300 fugu-section-padding3">
			<div className="container">
				<div className="fugu-section-title">
					<h2>Modern features that set apart from everyone else</h2>
				</div>
				<div className="fugu-iconbox-border">
					<div className="row">
						<div className="col-lg-4 col-md-6">
							<div className="fugu-iconbox-wrap6 wow fadeInUpX" data-wow-delay="0s">
								<div className="fugu-iconbox-icon6">
									<img src={icon1} alt="" />
								</div>
								<div className="fugu-iconbox-data6">
									<h4>Gather the information</h4>
									<p>
										It is a long established fact that a reader will be distracted by the readable
										content
									</p>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6">
							<div className="fugu-iconbox-wrap6 wow fadeInUpX" data-wow-delay=".10s">
								<div className="fugu-iconbox-icon6">
									<img src={icon2} alt="" />
								</div>
								<div className="fugu-iconbox-data6">
									<h4>Find solution and solve</h4>
									<p>
										It is a long established fact that a reader will be distracted by the readable
										content
									</p>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
							<div className="fugu-iconbox-wrap6 wow fadeInUpX" data-wow-delay=".20s">
								<div className="fugu-iconbox-icon6">
									<img src={icon3} alt="" />
								</div>
								<div className="fugu-iconbox-data6">
									<h4>Finally get the result</h4>
									<p>
										It is a long established fact that a reader will be distracted by the readable
										content
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
